import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, Lock } from "lucide-react";
import { ASSETS } from "@/lib/api";
import { Seo } from "@/components/Seo";

export default function Home() {
  return (
    <div className="bg-black min-h-screen relative overflow-hidden">
      <Seo
        title="CardScience HQ — Your Private Collector Vault"
        description="Your collection is worth more than you think. Create your free CardScience HQ account and discover what's inside. Private by default."
        path="/"
      />

      {/* vault hero backdrop */}
      <div className="absolute inset-0">
        <img src={ASSETS.vaultHero} alt="" aria-hidden className="w-full h-full object-cover opacity-60" />
        <div className="absolute inset-0" style={{ background: "radial-gradient(110% 80% at 50% 0%, rgba(0,0,0,0.25), rgba(0,0,0,0.78) 55%, #000 100%)" }} />
        <motion.div aria-hidden className="absolute inset-0"
          initial={{ opacity: 0.25 }} animate={{ opacity: [0.25, 0.5, 0.25] }}
          transition={{ duration: 7, repeat: Infinity, ease: "easeInOut" }}
          style={{ background: "radial-gradient(60% 50% at 50% 40%, rgba(36,224,255,0.10), transparent 70%)" }} />
      </div>

      {/* hero content */}
      <section className="relative z-10 min-h-screen flex flex-col items-center justify-center text-center px-5 py-28">
        <motion.p initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }}
          className="font-tech text-[11px] sm:text-xs tracking-[0.4em] text-[color:var(--chrome-3)] mb-7">
          CARDSCIENCE<span className="text-holo">HQ</span>
        </motion.p>

        <motion.h1 initial={{ opacity: 0, y: 18 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, delay: 0.1 }}
          className="h-display text-4xl sm:text-5xl lg:text-6xl text-white max-w-4xl leading-[1.05]">
          YOUR COLLECTION IS WORTH <span className="text-holo">MORE</span> THAN YOU THINK.
        </motion.h1>

        <motion.p initial={{ opacity: 0, y: 18 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, delay: 0.25 }}
          className="text-base sm:text-lg text-[color:var(--chrome-2)] mt-6 max-w-xl">
          Create your free CardScience HQ account and discover what&apos;s inside.
        </motion.p>

        <motion.div initial={{ opacity: 0, y: 18 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, delay: 0.4 }}
          className="mt-10 flex flex-col items-center gap-5">
          <Link to="/join" data-testid="open-account-cta"
            className="btn-holo inline-flex items-center gap-2.5 rounded-full px-10 py-5 text-sm sm:text-base tracking-wide">
            OPEN YOUR FREE ACCOUNT <ArrowRight size={18} />
          </Link>
          <p className="text-sm text-[color:var(--chrome-3)]">
            Already have an account?{" "}
            <Link to="/signin" data-testid="signin-link" className="text-[color:var(--cyan)] hover:underline">Sign In</Link>
          </p>
        </motion.div>

        <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 1, delay: 0.8 }}
          className="relative mt-14 sm:mt-0 sm:absolute sm:bottom-10 inline-flex items-center gap-2 text-xs font-tech tracking-widest text-[color:var(--chrome-3)] text-center justify-center px-4">
          <Lock size={13} className="text-[color:var(--cyan)] shrink-0" /> PRIVATE BY DEFAULT. YOUR COLLECTION STAYS YOURS.
        </motion.p>
      </section>
    </div>
  );
}
